import { REDUCE_OVERRIDABLE_ERRORS } from '../../constants/actions/policy';

export function reduceOverridableErrors(payload) {
    return {
        type: REDUCE_OVERRIDABLE_ERRORS,
        payload,
    };
}
